/**
 * US PDP sticky CTA — pins under the header after the hero Suggest a store CTA exits view.
 */
(function () {
  const BAR_SELECTOR = '[data-pdp-us-sticky-cta]';
  const HERO_CTA_SELECTOR =
    '.product-information .us-showcase-cta__button, .product-details .us-showcase-cta__button';

  /**
   * #header-group is display:contents (height 0) — measure the sticky .header-section instead.
   */
  function headerOffset() {
    const header = document.getElementById('header-component');
    const headerSection = header?.closest?.('.header-section');
    const anchor =
      headerSection instanceof HTMLElement
        ? headerSection
        : document.querySelector('.header-section.main-header') ||
          document.querySelector('sticky-header') ||
          document.querySelector('#header-group');

    if (!(anchor instanceof HTMLElement)) return 0;

    const rect = anchor.getBoundingClientRect();
    /*
      Use the live bottom edge whenever the header is on screen, not just once it
      is pinned. Until the announcement bar scrolls away the header starts below
      it, so its own height is short of where the bar has to begin and the bar
      lands inside the header band — which paints over it (header z-index is 13,
      the bar's is 12).
    */
    if (rect.bottom > 0 && rect.top < window.innerHeight) {
      return Math.max(0, Math.round(rect.bottom));
    }

    const height = Math.round(anchor.offsetHeight);
    return height > 0 ? height : 0;
  }

  function placeBar(bar) {
    const top = headerOffset();
    bar.style.setProperty('--us-pdp-sticky-top', top + 'px');
    bar.style.top = top + 'px';
    bar.style.bottom = 'auto';
    bar.style.position = 'fixed';
    document.documentElement.style.setProperty('--us-pdp-sticky-height', Math.round(bar.offsetHeight) + 'px');
  }

  function setVisible(bar, visible) {
    bar.classList.toggle('is-visible', visible);
    bar.toggleAttribute('hidden', !visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    /* Keep hidden sticky CTAs out of the tab order (WCAG 2.4.3). */
    if (visible) {
      bar.removeAttribute('inert');
      placeBar(bar);
    } else {
      bar.setAttribute('inert', '');
      document.documentElement.style.setProperty('--us-pdp-sticky-height', '0px');
    }
  }

  function init() {
    const bar = document.querySelector(BAR_SELECTOR);
    if (!(bar instanceof HTMLElement)) return;

    const heroCta = document.querySelector(HERO_CTA_SELECTOR);
    if (!(heroCta instanceof HTMLElement)) {
      setVisible(bar, false);
      return;
    }

    placeBar(bar);
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (bar.classList.contains('is-visible')) placeBar(bar);
      }).observe(bar);
    }
    window.addEventListener(
      'resize',
      function () {
        placeBar(bar);
      },
      { passive: true }
    );
    window.addEventListener(
      'scroll',
      function () {
        if (bar.classList.contains('is-visible')) placeBar(bar);
      },
      { passive: true }
    );

    if (!('IntersectionObserver' in window)) {
      const onScroll = () => {
        const rect = heroCta.getBoundingClientRect();
        setVisible(bar, rect.bottom < headerOffset());
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }

    let observer = null;

    function observe() {
      if (observer) observer.disconnect();
      const top = headerOffset();
      observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          /*
            Out of view means above or below, and on mobile the tall media pushes
            the hero CTA below the fold at load — so isIntersecting alone showed
            the bar before the reader had ever reached the CTA it repeats. Require
            the CTA to have gone up past the header instead.
          */
          const rootTop = entry.rootBounds ? entry.rootBounds.top : top;
          setVisible(bar, !entry.isIntersecting && entry.boundingClientRect.bottom <= rootTop);
        },
        { root: null, threshold: 0, rootMargin: '-' + top + 'px 0px 0px 0px' }
      );
      observer.observe(heroCta);
    }

    observe();
    window.addEventListener('resize', observe, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
